// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/rda/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","societaId":"number","numero":"number","anno":"number","etichetta":"string","stato":"APERTA|EVASA|ANNULLATA","note":"string|null","createdAt":"string","annullataAt":"string|null","createdBy":{"id":"number","nome":"string"},"annullataDa":{"id":"number","nome":"string"},"righe":[{"id":"number","ordinePos":"number","articoloId":"number|null","descrizione":"string","unitaMisura":"string|null","quantita":"number","quantitaOrdinata":"number","note":"string|null","rigaOrdineId":"number|null","componenteId":"number|null","rigaDistintaId":"number|null","ordineId":"number|null","commessaId":"number|null","articolo":{"id":"number","codice":"string","descrizioneBase":"string","tipologia":"string","fornitore":{"id":"number","ragioneSociale":"string"}},"ordine":{"id":"number","numero":"string"},"commessa":{"id":"number","numero":"string","descrizione":"string"}}],"logs":[{"id":"number","utenteName":"string","azione":"string","dettaglio":"string","createdAt":"string"}]}}'
  },
  {
    method: 'POST',
    endpoint: '/api/rda/:id/annulla',
    requestBody: '{"motivo":"string|null"}',
    response: '{"success":true,"data":{"stato":"ANNULLATA"}}'
  },
  {
    method: 'PUT',
    endpoint: '/api/rda/:id',
    requestBody: '{"note":"string|null"}',
    response: '{"success":true}'
  },
  {
    method: 'PUT',
    endpoint: '/api/rda/:id',
    requestBody: '{"righe":[{"articoloId":"number|null","descrizione":"string","unitaMisura":"string|null","quantita":"number","note":"string|null","rigaOrdineId":"number|null","componenteId":"number|null","rigaDistintaId":"number|null","ordineId":"number|null","commessaId":"number|null"}]}',
    response: '{"success":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
